import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
	selector: 'app-price-reactive-form',
	templateUrl: './price-reactive-form.component.html',
	styleUrls: ['./price-reactive-form.component.scss']
})
export class PriceReactiveFormComponent {

	/**
	 * Form group
	 */
	private _form: FormGroup;

	/**
	 * The form group
	 */
	@Input()
	get form(): FormGroup { return this._form; };
	set form(_form: FormGroup) {
		this._form = _form;
		this.netControl?.valueChanges?.subscribe(x => this.updatePrices('net'));
		this.taxControl?.valueChanges?.subscribe(x => this.updatePrices('tax'));
		this.grossControl?.valueChanges?.subscribe(x => this.updatePrices('gross'));
	}

	/**
	 * min: number
	 */
	@Input()
	public min: number | string = '';

	/**
	 * Sets header
	 */
	@Input()
	public header: boolean;

	/**
	 * readonly
	 */
	@Input()
	public readonly: boolean;

	/**
	 * Extanded: boolean
	 */
	@Input()
	public options: any = {};

	/**
	 * Change callback
	 */
	@Output()
	public priceChange: EventEmitter<any> = new EventEmitter<any>();

	/**
	 * Gets net control
	 */
	get netControl(): AbstractControl { return this.form?.controls['net']; }

	/**
	 * Gets tax control
	 */
	get taxControl(): AbstractControl { return this.form?.controls['tax']; }

	/**
	 * Gets gross control
	 */
	get grossControl(): AbstractControl { return this.form?.controls['gross']; }

	/**
	 * Gets taxAmount control
	 */
	get taxAmountControl(): AbstractControl { return this.form?.controls['taxAmount']; }

	/**
	 * Updates prices
	 * @param event 
	 */
	public updatePrices(fieldName: string) {
		switch (fieldName) {
			case 'net':
			case 'tax':
				this.form.patchValue({ gross: (this.netControl.value * (1 + this.taxControl.value / 100)).round(5) }, { emitEvent: false });
				this.form.patchValue({ taxAmount: (this.grossControl.value - this.netControl.value).round(5) }, { emitEvent: false });
				break;

			case 'gross':
				this.form.patchValue({ net: (this.grossControl.value / (1 + this.taxControl.value / 100)).round(5) }, { emitEvent: false });
				this.form.patchValue({ taxAmount: (this.grossControl.value - this.netControl.value).round(5) }, { emitEvent: false });
				break;
		}

		/* Emit change event */
		this.priceChange.emit(this.form?.value);
	}
}